export default "__VITE_ASSET__ufY108ca__"